"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchParams = exports.composeLink = void 0;
const getSearchParams = object => {
  const params = Object.entries(object).filter(([, value]) => value !== undefined && value !== null).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  return params.length > 0 ? `?${params.join('&')}` : '';
};
exports.getSearchParams = getSearchParams;
const composeLink = (baseUrl, parameters) => baseUrl + getSearchParams(parameters);
exports.composeLink = composeLink;